import React from "react";
import {MyButton} from "../SimpleComponents/MyButton";
import './MainScreen.css';
import {Dropdown} from "react-bootstrap";
import {Link} from "react-router-dom";


class MainScreen extends React.Component {


	constructor(props) {
		super(props);

		this.state = {
			showMenu: false,
		};

		this.showMenu = this.showMenu.bind(this);
	}

	showMenu(event) {
		event.preventDefault();

		this.setState({showMenu: !this.state.showMenu}, () => {});

	}

	render() {
		return (
			<div className='background1'>


				<div className="hero-container">

					<div className='margin_top'></div>

					<h1 className='title center'>Fusic</h1>

					<p className='subtitle center'>Praca na konkurs fizyczny "Młody Einstein"</p>

					<div className="hero-btns center">

						<button className="btnRecording btns" buttonSize="btn--large" buttonStyle="btn--outline" id="buttonik">
							<Link to="dzwiek" style={{userSelect: "none", textDecoration: "none",
							color:"#000000"}}>Start</Link>
						</button>

					</div>

					{/*<div className='btn-menu center'>
						<MyButton className="btns" onClick={this.showMenu} buttonSize="btn--large" buttonStyle="btn--outline" id="buttonik">
							Pokaż menu
						</MyButton>
					</div>*/}

					{/*
						this.state.showMenu
							? (
								<div
									className="menu"
									ref={(element) => {
										this.dropdownMenu = element;
									}}
								>
									<Dropdown.Item className='menu-item'> Menu item 1 </Dropdown.Item>
									<Dropdown.Item className='menu-item'> Menu item 2 </Dropdown.Item>
									<Dropdown.Item className='menu-item'> Menu item 3 </Dropdown.Item>
								</div>
							)
							: (
								null
							)
					*/}

				</div>
			</div>
		);
	}
}
export default MainScreen;